import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#095CAA' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3.731 4.097a.75.75 0 01.75.75v3.75h3.75a.75.75 0 110 1.5h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.996 3.173a9 9 0 013.889 17.571.75.75 0 11-.355-1.457A7.502 7.502 0 0020.255 12 7.5 7.5 0 007.449 6.699L4.26 9.879A.75.75 0 113.2 8.816l3.187-3.177a9 9 0 014.608-2.466z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.359 15.206a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.281 13.875H5.72v5.25H9.28v-5.25zm.469-1.5c.57 0 1.031.462 1.031 1.031v6.188c0 .57-.462 1.031-1.031 1.031h-4.5c-.57 0-1.031-.462-1.031-1.031v-6.188c0-.57.461-1.031 1.031-1.031h4.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
